import { Phone, Mail, MapPin } from "lucide-react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";

export default function Footer() {
  const links = [
    { name: "Home", id: "home" },
    { name: "About", id: "about" },
    { name: "Services", id: "services" },
    { name: "Projects", id: "projects" },
    { name: "Contact", id: "contact" },
  ];

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-[#020617] text-white pt-20 pb-10 px-6 overflow-hidden">

      {/* Glow background */}
      <div className="absolute w-[350px] h-[350px] bg-teal-500 blur-[120px] opacity-20 top-0 left-0"></div>
      <div className="absolute w-[350px] h-[350px] bg-blue-500 blur-[120px] opacity-20 bottom-0 right-0"></div>

      <div className="max-w-7xl mx-auto relative z-10">

        <div className="grid md:grid-cols-4 gap-10">

          {/* BRAND */}
          <div>
            <h2 className="text-2xl font-bold mb-4">🦚 Aysu Groups</h2>
            <p className="text-gray-400 text-sm leading-relaxed">
              We build modern websites, branding, and digital solutions to grow your business.
            </p>

            <div className="mt-4 text-green-400 text-sm flex items-center gap-2">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
              24/7 Support Available
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              {links.map((link, i) => (
                <li key={i}>
                  <button
                    onClick={() => scrollTo(link.id)}
                    className="hover:text-teal-400 transition"
                  >
                    ➤ {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* CONTACT DETAILS (MOVED FROM CONTACT PAGE STYLE) */}
          <div>
  <h3 className="font-semibold mb-4">Contact Info</h3>

  <div className="space-y-3 text-gray-400 text-sm">

    {/* PHONE */}
    <a
      href="tel:+919361226606"
      className="flex items-center gap-3 bg-white/5 p-3 rounded-xl border border-white/10 hover:border-teal-400 transition"
    >
      <Phone size={16} className="text-teal-400" />
      <span>+91 93612 26606</span>
    </a>

    {/* EMAIL */}
    <a
      href="mailto:aysugroups@gmail.com"
      className="flex items-center gap-3 bg-white/5 p-3 rounded-xl border border-white/10 hover:border-teal-400 transition"
    >
      <Mail size={16} className="text-teal-400" />
      <span>aysugroups@gmail.com</span>
    </a>

    {/* LOCATION (already good) */}
    <a
      href="https://www.google.com/maps?q=9.1754375,77.8826094"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 bg-white/5 p-3 rounded-xl border border-white/10 hover:border-teal-400 transition cursor-pointer w-full"
    >
      <MapPin size={16} className="text-teal-400" />
      <span>Kovilpatti, Tamil Nadu</span>
    </a>

  </div>
</div>
          {/* SOCIAL MEDIA (MOVED FROM CONTACT PAGE STYLE) */}
          <div>
            <h3 className="font-semibold mb-4">Follow Us</h3>

            <div className="flex gap-3">

              <a href="https://www.youtube.com/@AYSUGROUPS" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl border border-white/10 hover:bg-red-500 transition">
                <FaYoutube />
              </a>

              <a href="https://www.facebook.com/people/Kaviya-Akshaya-A/61564407896545/#" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl border border-white/10 hover:bg-blue-600 transition">
                <FaFacebookF />
              </a>

              <a href="https://www.instagram.com/aysu_groups?utm_source=qr&igsh=MWJqZDJmMGtoMXdrNA==" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl border border-white/10 hover:bg-pink-500 transition">
                <FaInstagram />
              </a>

              <a href="https://www.linkedin.com/in/akshayaaysu/" className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-xl border border-white/10 hover:bg-blue-400 transition">
                <FaLinkedinIn />
              </a>

            </div>

            <p className="text-gray-500 text-xs mt-4">
              Follow us for updates, projects & insights 🚀
            </p>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">

          <p>© {new Date().getFullYear()} Aysu Groups. All rights reserved.</p>

          <p className="mt-2 md:mt-0">
            Built with ❤️ by Aysu Groups Team
          </p>
        </div>
      </div>
    </footer>
  );
}